import classNames from "classnames";

import styles from "./Tabs.module.scss";

interface Tab {
  value: string;
  label: string;
  component: React.ReactNode;
}

interface TabsProps {
  selectedTab: string;
  onTabChange: (tab: string) => void;
  tabs: Tab[];
}

export const Tabs: React.FC<TabsProps> = ({ tabs, selectedTab, onTabChange }) => {
  return (
    <>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className={classNames(styles.tab, { [styles.active]: tab.value === selectedTab })}
            onClick={() => onTabChange(tab.value)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      {tabs.find((tab) => tab.value === selectedTab)?.component}
    </>
  );
};
